import React, { Component } from 'react';
import NotificationSystem from 'react-notification-system';
import Gallery from './Gallery';

export default class Index extends Component {
    render() {
        // console.log(this.state);
        return (
            <div role="form" id="galleryPage">
                <NotificationSystem ref="notificationSystem" />

                <Gallery {...this.props} />
            </div>
        )
    }

}


/** WEBPACK FOOTER **
 ** ./src/components/patient/Gallery/Index.js
 **/